import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import subscribeFunctional from './index.function';
import TermsModal from '../../components/TermsModal';
import {
  SingleDocumentView,
  SubscribeCard,
  SuitabilityModal,
} from './components';
import { Formik } from 'formik';
import {
  subscribe_schema,
  subscribe_validation_schema,
} from '../../validations_schemas/subscribe_validation_schema';
import CustomInput from '../../components/CustomInput';
import ViewReverse from '../../components/ViewReverse';
import ErrorText from '../../components/ErrorText';
import { cn, formatNumbers } from '../../utils/utils';
import { rowReverseStylemd } from '../../utils/styles';
import Button from '../../components/Button';
import CustomCheckbox from '../../components/CustomCheckbox';
import CustomModal from '../../components/CustomModal';
import dayjs from 'dayjs';
import SarSymbol from '../../components/SarSymbol';
import SuccessModal from '../../components/SuccessModal';
import Loader from '../../components/Loader';
import LoaderModal from '../../components/LoaderModal';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { integer_regex } from '../../utils/functions';

const Subscribe = () => {
  const {
    item,
    isArabic,
    fund_detail,
    TextWeight,
    fund_loading,
    getContentKey,
    handleReviewSubscribe,
    onVerify,
    isTermsModal,
    setIsTermModal,
    reviewModal,
    toogleReviewModal,
    documentUrls,
    onPressAgree,
    successMessage,
    successModal,
    setSuccessModal,
    navigate,
    fund_document_loading,
    subscription,
    total_amount,
    amount,
    vat,
    selectedDocument,
    setSelectedDocument,
    isSuitabilityModal,
    setIsSuitabilityModal,
    handleGenerateSuitability,
    direction,
    units,
    handleDownloadFile,
  } = subscribeFunctional();

  const documents_array = fund_detail?.documents?.filter((val) => val?.documentTypeId !== 5 && val?.documentTypeId !== 4);
  const terms_document = fund_detail?.documents?.find((val) => val?.documentTypeId === 4);
  const terms_document_url = documentUrls?.find((val) => val?.typeId === 4);
  const validate_documents_array = documents_array?.filter(val => val?.documentTypeId !== 1);
  const document_ids = [terms_document?.documentId, ...(validate_documents_array ?? [])?.map(val => val?.documentId)]

  return (
    <div className='min-h-full'>
      <Text
        text={getContentKey('heading')}
        size={fontSizes.h18}
        weight={TextWeight.bold}
      />

      <Formik
        validationSchema={subscribe_validation_schema}
        initialValues={subscribe_schema}
        validateOnChange={false}
        validateOnMount={false}
        validateOnBlur={false}
        onSubmit={(values, functions) =>
          handleReviewSubscribe(values, functions?.resetForm)
        }
      >
        {({
          handleSubmit,
          setFieldValue,
          values,
          errors,
          resetForm,
        }) => {

          const total_amount = Number(values?.unit || 0) * (fund_detail?.lastPrice || 0)
          const is_minimum = total_amount < fund_detail?.minSubscriptionAmount;
          const is_maximum = total_amount > fund_detail?.maxSubscriptionAmount;

          const other_documents = documentUrls?.filter(val => val?.typeId !== 4)
          const is_valid = fund_detail && values?.unit?.length > 0 && total_amount <= fund_detail?.maxSubscriptionAmount &&
            total_amount >= fund_detail?.minSubscriptionAmount && (validate_documents_array?.length > 0 ? other_documents?.length === validate_documents_array?.length : true) && terms_document_url?.messageNDA;

          return (
            <div className='mt-2'>
              <ViewReverse>
                <div className='w-full sm:w-1/2'>
                  <CustomInput
                    value={fund_detail?.fundName ?? item?.fundName ?? ''}
                    // label={getContentKey('fund_sar')}
                    isRounded
                    isDisabled
                  />
                </div>
              </ViewReverse>

              <div dir={direction} className='my-4'>
                <SubscribeCard item={fund_detail ?? item} isSubscribe={false} />
              </div>

              <ViewReverse>
                <Text
                  text={getContentKey('view_suitability_report') + ' *'}
                  size={fontSizes.h14}
                  weight={TextWeight.semiBold}
                  isTruncate={false}
                  className={'underline cursor-pointer inline'}
                  color='text-primary'
                  onClick={() => handleGenerateSuitability()}
                />
              </ViewReverse>

              <ViewReverse
                className={cn(
                  'gap-5 mt-6 flex-col ',
                  rowReverseStylemd(isArabic),
                )}
              >
                {fund_loading ? (
                  <Loader />
                ) : (
                  documents_array?.map((val, index) => {
                    const document = documentUrls?.find(
                      (item) => item?.documentId === val?.documentId,
                    )?.messageNDA;
                    return (
                      <SingleDocumentView
                        key={index}
                        label={val?.documentTypeName}
                        onClick={() => handleDownloadFile(document || val?.documentFileUrl)}
                        getContentKey={getContentKey}
                        onView={() => {
                          setIsTermModal(true);
                          setSelectedDocument(document || val?.documentFileUrl);
                        }}
                      />
                    );
                  })
                )}
              </ViewReverse>
              <div className='pt-3 sm:pt-5'>
                <Text
                  text={getContentKey('per_unit_price')}
                  size={fontSizes.h14}
                  color='text-primary'
                  weight={TextWeight.medium}
                />
                <Text
                  text={fund_detail?.lastPrice}
                  size={fontSizes.h26}
                  weight={TextWeight.medium}
                  color='text-black'
                  leftSymbol
                />
              </div>
              <ViewReverse>
                <div className='w-full sm:w-1/2 pt-2 sm:pt-4'>
                  <CustomInput
                    label={getContentKey('subscription_units')}
                    placeholder={getContentKey('unit_placeholder')}
                    isRounded
                    value={values?.unit}
                    onChange={(e) => {
                      const unit = e?.target?.value;
                      const isUnit = integer_regex.test(unit);
                      if (unit?.length > 0) {
                        if (isUnit) {
                          setFieldValue('unit', unit);
                        }
                      } else {
                        setFieldValue('unit', unit);
                      }
                    }}
                    maxLength={20}
                    isError={errors?.unit}
                    isRequired
                  />
                </div>
              </ViewReverse>
              <div className='pt-3 sm:pt-5'>
                <Text
                  text={getContentKey('subscription_amount')}
                  size={fontSizes.h14}
                  color='text-primary'
                  weight={TextWeight.medium}
                />

                <Text
                  text={formatNumbers(total_amount)}
                  size={fontSizes.h26}
                  weight={TextWeight.medium}
                  color='text-black'
                  leftSymbol
                />
              </div>
              {values?.unit?.length > 0 && (is_minimum || is_maximum) &&
                <ErrorText text={getContentKey(is_minimum ? "suffiecient_amount" : "exceed_amount")} />
              }
              {fund_detail?.feeApplicable && (
                <div className='pt-2 sm:pt-4'>
                  <Text
                    text={getContentKey('a') + ` ${fund_detail?.feeApplicable ? fund_detail?.feeValueInPer : 0}` + getContentKey('fee_disclaimer')}
                    size={fontSizes.h14}
                    weight={TextWeight.regular}
                    color='text-silver'
                    isTruncate={false}
                  />
                </div>
              )}

              {isArabic ? (
                <ViewReverse className='gap-7 w-full'>
                  <CustomCheckbox
                    isChecked={terms_document_url?.messageNDA}
                    disabled={terms_document_url?.messageNDA || fund_loading}
                    label={
                      <div className='flex items-center gap-1'>
                        <Text
                          text={getContentKey('terms_before')}
                          size={fontSizes.h14}
                          weight={TextWeight.medium}
                        />
                        <Text
                          text={getContentKey('terms_text')}
                          size={fontSizes.h14}
                          color={'text-primary'}
                          weight={TextWeight.medium}
                          className={'mx-1 cursor-pointer underline'}
                          onClick={() => {
                            window.open(terms_document?.documentFileUrl, '_blank')
                          }}
                        />
                        <Text
                          text={getContentKey('terms_after')}
                          size={fontSizes.h14}
                          weight={TextWeight.medium}
                        />
                      </div>
                    }
                    className={'mt-4'}
                    onClick={() => onPressAgree(document_ids)}
                    onPressSecondText={() => window.open(terms_document?.documentFileUrl, '_blank')}
                  />
                </ViewReverse>
              ) : (
                <ViewReverse className='gap-7 w-full'>
                  <CustomCheckbox
                    isChecked={terms_document_url?.messageNDA}
                    disabled={terms_document_url?.messageNDA || fund_loading}
                    label={getContentKey('i_understand_and_agree')}
                    secondText={
                      <Text
                        text={getContentKey('termsand_conditions')}
                        size={fontSizes.h14}
                        color={'text-primary'}
                        weight={TextWeight.medium}
                        className={'cursor-pointer underline'}
                        onClick={() => window.open(terms_document?.documentFileUrl, '_blank')}
                      />
                    }
                    className={'mt-4'}
                    onClick={() => onPressAgree(document_ids)}
                  />
                </ViewReverse>
              )}

              <div className='border-t border-grey h-1 mt-3 w-full'></div>

              <ViewReverse className='gap-2 sm:gap-3 mt-2 sm:mt-4'>
                <Button
                  text={getContentKey('review_btn')}
                  bgColor='bg-primary'
                  className={
                    'w-full sm:w-fit sm:px-10 rounded-lg capitalize py-2 text-center'
                  }
                  onClick={() => {
                    setFieldValue('is_submit', true);
                    handleSubmit();
                  }}
                  isDisabled={!is_valid || fund_loading}
                />
                <Button
                  text={getContentKey('clear_btn')}
                  bgColor='bg-white'
                  color='text-primary'
                  className={
                    'w-full sm:w-fit sm:px-16 rounded-lg capitalize py-2 text-center border border-primary'
                  }
                  onClick={resetForm}
                />
              </ViewReverse>

              <SuitabilityModal
                open={isSuitabilityModal}
                agree={values?.read_suitability_report}
                toogleAgree={() =>
                  setFieldValue(
                    'read_suitability_report',
                    !values?.read_suitability_report,
                  )
                }
                getContent={getContentKey}
                onPressOkay={(isSutibile) => {
                  if (isSutibile) {
                    setFieldValue(
                      'read_suitability_report',
                      true,
                    )
                  }
                  setIsSuitabilityModal(false);
                  values?.is_submit && handleSubmit();
                }}
              />
            </div>
          );
        }}
      </Formik>

      <CustomModal
        isOpen={reviewModal}
        heading={getContentKey('heading')}
        isFullWidth
        onClose={toogleReviewModal}
      >
        <Text
          text={getContentKey('subscribe_summary')}
          color='text-text-grey/60'
          size={fontSizes.h14}
        />

        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('fund')} size={fontSizes.h14} />
          <Text
            text={fund_detail?.fundName}
            size={fontSizes.h14}
            color='text-primary'
            weight={TextWeight.semiBold}
          />
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('terms_condition')} size={fontSizes.h14} />
          <ViewReverse className={'items-center gap-3'}>
            <Text
              dir={"ltr"}
              text={dayjs().format('DD MMM, YYYY')}
              size={fontSizes.h14}
              color='text-primary'
              weight={TextWeight.semiBold}
              onClick={() => window.open(terms_document?.documentFileUrl, '_blank')}
              align={'text-left'}
            />
            <ReactSVG
              src={icons?.viewActionbtn}
              className='cursor-pointer'
              onClick={() => window.open(terms_document?.documentFileUrl, '_blank')}
            />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('transaction_type')} size={fontSizes.h14} />
          <Text
            text={getContentKey('cash_account')}
            size={fontSizes.h14}
            color='text-primary'
            weight={TextWeight.semiBold}
          />
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('amount')} size={fontSizes.h14} />
          <ViewReverse isReverse={false}>
            <SarSymbol color={'text-primary'} />
            <Text
              text={formatNumbers(amount)}
              size={fontSizes.h14}
              color='text-primary'
              weight={TextWeight.semiBold}
            />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('units')} size={fontSizes.h14} />
          <ViewReverse>
            {/* <SarSymbol color={'text-primary'} /> */}
            <Text
              text={formatNumbers(units, 0)}
              size={fontSizes.h14}
              color='text-primary'
              weight={TextWeight.semiBold}
            />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('subscription_fee')} size={fontSizes.h14} />
          <ViewReverse isReverse={false}>
            <SarSymbol color={'text-primary'} />
            <Text
              dir={'ltr'}
              text={`${subscription > 0 ? subscription?.toFixed(2) : 0} (${fund_detail?.feeApplicable ? fund_detail?.feeValueInPer : 0}%)`}
              size={fontSizes.h14}
              color='text-primary'
              weight={TextWeight.semiBold}
              align={'text-left'}
            />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('vat')} size={fontSizes.h14} />
          <ViewReverse isReverse={false}>
            <SarSymbol color={'text-primary'} />
            <Text
              dir={'ltr'}
              text={`${vat > 0 ? vat?.toFixed(2) : 0} (${fund_detail?.vatApplicable ? fund_detail?.vatValueInPer : 0}%)`}
              size={fontSizes.h14}
              color='text-primary'
              weight={TextWeight.semiBold}
              align={'text-left'}
            />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('total_amount')} size={fontSizes.h14} />
          <ViewReverse isReverse={false}>
            <SarSymbol color={'text-primary'} />
            <Text
              text={formatNumbers(total_amount)}
              size={fontSizes.h14}
              color='text-primary'
              weight={TextWeight.semiBold}
            />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('date')} size={fontSizes.h14} />
          <Text
            dir={"ltr"}
            text={dayjs().format('DD MMM, YYYY')}
            size={fontSizes.h14}
            color='text-primary'
            weight={TextWeight.semiBold}
            align={'text-left'}
          />
        </ViewReverse>

        <ViewReverse className='items-center w-full justify-end gap-2 mt-3'>
          <Button
            text={getContentKey('review_btn')}
            bgColor='bg-primary'
            className={'w-full px-0 text-center border border-orange'}
            onClick={onVerify}
            loading={fund_loading}
          />
        </ViewReverse>
      </CustomModal>

      <SuccessModal
        open={successModal}
        onClose={() => {
          setSuccessModal(false);
          navigate(-1);
        }}
        title={getContentKey('thank_you')}
        description={successMessage}
      />

      <TermsModal
        isOpen={isTermsModal}
        onClose={() => setIsTermModal(false)}
        // src={fund_detail?.sutibilityReport?.jsrS_Content}
        url={selectedDocument}
      />

      <LoaderModal open={fund_document_loading} />
    </div>
  );
};

export default Subscribe;
